/* P.O.M 3D MASTER — Motion Engine (no dependencies) */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(pointer: fine)');

  /* ---------- 1. Entrance ---------- */
  function initReveal() {
    var items = document.querySelectorAll('[data-pom-reveal]:not([data-pom-observed])');
    if (!items.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.setAttribute('data-pom-observed', '');
        el.classList.add('pom-in');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-pom-delay') || '0', 10);
        setTimeout(function () { el.classList.add('pom-in'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });

    items.forEach(function (el) {
      el.setAttribute('data-pom-observed', '');
      io.observe(el);
    });
  }

  /* ---------- 2. Parallax ---------- */
  var layers = [];
  var ticking = false;

  function collectLayers() {
    layers = Array.prototype.slice.call(document.querySelectorAll('[data-pom-speed]'));
  }

  function applyParallax() {
    ticking = false;
    var vh = window.innerHeight;
    var mobile = window.innerWidth < 900;
    for (var i = 0; i < layers.length; i++) {
      var el = layers[i];
      var rect = el.getBoundingClientRect();
      if (rect.bottom < -200 || rect.top > vh + 200) continue;
      var speed = parseFloat(el.getAttribute('data-pom-speed')) || 0;
      var progress = (rect.top + rect.height / 2 - vh / 2) / vh; // -1 .. 1
      var max = mobile ? 20 : 40;
      var shift = progress * (1 - speed) * max * -1;
      el.style.setProperty('--pom-shift', shift.toFixed(2) + 'px');
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(applyParallax);
  }

  /* ---------- 3. Hero-Tilt ---------- */
  function initTilt() {
    if (reduced.matches || !fine.matches) return;
    var stages = document.querySelectorAll('.pom-hero:not([data-pom-tilt-bound])');

    stages.forEach(function (hero) {
      var target = hero.querySelector('.pom-hero__product');
      if (!target) return;
      hero.setAttribute('data-pom-tilt-bound', '');

      var raf = null;
      var tx = 0, ty = 0, cx = 0, cy = 0;
      var MAX = 12;

      function loop() {
        cx += (tx - cx) * 0.08;
        cy += (ty - cy) * 0.08;
        target.style.setProperty('--pom-tilt-x', cx.toFixed(2) + 'deg');
        target.style.setProperty('--pom-tilt-y', cy.toFixed(2) + 'deg');
        if (Math.abs(tx - cx) > 0.05 || Math.abs(ty - cy) > 0.05) {
          raf = window.requestAnimationFrame(loop);
        } else {
          raf = null;
          target.classList.remove('pom-tilting');
        }
      }

      function start() {
        target.classList.add('pom-tilting');
        if (!raf) raf = window.requestAnimationFrame(loop);
      }

      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width - 0.5;
        var py = (e.clientY - r.top) / r.height - 0.5;
        ty = px * MAX * 2;
        tx = py * MAX * -2;
        start();
      });

      hero.addEventListener('pointerleave', function () {
        tx = 0; ty = 0;
        start();
      });
    });
  }

  /* ---------- Boot ---------- */
  function boot() {
    initReveal();
    collectLayers();
    initTilt();
    applyParallax();
    document.querySelectorAll('.pom-hero').forEach(function (h) { h.classList.add('pom-in'); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { collectLayers(); onScroll(); }, { passive: true });

  /* Shopify Theme-Editor */
  document.addEventListener('shopify:section:load', boot);
})();
